import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'

const HomePage = () => import('../components/public/pages/HomePage.vue')
const PricingPage = () => import('../components/public/pages/PricingPage.vue')
const HowToUsePage = () => import('../components/public/pages/HowToUsePage.vue')
const EquipmentPage = () => import('../components/public/pages/EquipmentPage.vue')
const AccessPage = () => import('../components/public/pages/AccessPage.vue')
const FAQPage = () => import('../components/public/pages/FAQPage.vue')
const ContactPage = () => import('../components/public/pages/ContactPage.vue')
const PrivacyPolicyPage = () => import('../components/public/pages/PrivacyPolicyPage.vue')
const CommerceLawPage = () => import('../components/public/pages/CommerceLawPage.vue')

const routes: RouteRecordRaw[] = [
  { path: '/', name: 'home', component: HomePage },
  { path: '/pricing', name: 'pricing', component: PricingPage },
  { path: '/how-to-use', name: 'how-to-use', component: HowToUsePage },
  { path: '/equipment', name: 'equipment', component: EquipmentPage },
  { path: '/access', name: 'access', component: AccessPage },
  { path: '/faq', name: 'faq', component: FAQPage },
  { path: '/contact', name: 'contact', component: ContactPage },
  { path: '/privacy-policy', name: 'privacy-policy', component: PrivacyPolicyPage },
  { path: '/legal/commerce', name: 'legal-commerce', component: CommerceLawPage },
  { path: '/:pathMatch(.*)*', redirect: '/' },
]

export function createAppRouter(initialPath: string = '/') {
  const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(_to, _from, savedPosition) {
      if (savedPosition) return savedPosition
      return { top: 0 }
    },
  })

  // 初期パスが現在のURLと異なる場合は置換
  if (initialPath !== '/' && initialPath !== window.location.pathname) {
    router.replace(initialPath)
  }

  return router
}
